import { memo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "../Modal";
import { AddRouteContent } from "./AddRouteContent";
import { AddRouteActions } from "./AddRouteActions";
import { addRouteModalOpenSelector } from "../../../reducers/ownApp/selectors";
import { setAddRouteModalOpen } from "../../../reducers/ownApp";
import { addRoute } from "../../../reducers/routeManagement/thunkActions";
import {
  maxAdditionalMinutesSelector,
  routeConfigSelector,
  routesSelector,
} from "../../../reducers/routeManagement/selectors";
import { validateRoute } from "../../../utils/routes";

export const AddRouteModal = memo(() => {
  const dispatch = useDispatch();
  const open = useSelector(addRouteModalOpenSelector);
  const maxAdditionalMinutes = useSelector(maxAdditionalMinutesSelector);
  const routeConfig = useSelector(routeConfigSelector);
  const routes = useSelector(routesSelector);
  const [routeCode, setRouteCode] = useState("");
  const route = {
    routeCode,
    additionalMinutes: "00:00",
    useToll: false,
    useFerry: false,
    roadSpeeds: Object.values(routeConfig).map(
      ({ roadCode, description, urban, rural }) => ({
        roadCode,
        description,
        urban,
        rural,
      })
    ),
  };

  useEffect(() => {
    setRouteCode("");
  }, [open]);

  const onClose = () => dispatch(setAddRouteModalOpen(false));
  const onContinue = async () => {
    dispatch(addRoute({ route }));
    onClose();
  };

  const errors = validateRoute({
    route,
    maxAdditionalMinutes,
    routeConfig,
    existingRoutes: routes,
  });

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={"Add New Route"}
      content={
        <AddRouteContent
          onRouteCodeChange={({ target }) => setRouteCode(target.value)}
          routeCode={routeCode}
          errors={errors}
        />
      }
      actions={
        <AddRouteActions
          disabled={!!Object.keys(errors).length}
          onCancel={onClose}
          onContinue={onContinue}
        />
      }
      maxWidth={"sm"}
    />
  );
});
